module.exports = __webpack_public_path__ + "img/portugal-ill-defined-causes-female.baa29dbb.png";